import { useState, useEffect } from "react";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";

const winnersData = [
  {
    category: "Pravartak Award",
    id: "U1UCI345",
    domain: "Drilling, Rajahmundry Asset",
    title: "AI-powered Hole Cleaning Monitoring System using Physics-based and Computer Vision models",
    team: ["Bala Saidulu Nallagondla", "Rajjan Singh Thakur", "Santosh Kumar Gupta", "Ramu Pedumajji", "Murugesan M K", "Janeshwar Prasad", "Raghu Ottoor Menon", "Mathialagan P", "Srinivasan J"]
  },
  {
    category: "Pravartak Award",
    id: "U1UCI512",
    domain: "Reservoir, KDMIPE Dehradun",
    title: "Water Injection Optimization on Oil Reservoirs",
    team: ["Aninda Ghosh", "Anil Thapliyal", "Naveen Kumar M", "Rakesh Sarkar", "Pratik R Kumawat", "A Rangaswamy"]
  },
  {
    category: "Pravartak Award",
    id: "U1UCI013",
    domain: "G&G, Frontier Basin Dehradun",
    title: "Full Waveform Inversion (FWI) for Advanced Seismic Model Building",
    team: ["Smitha NC", "Sanjai Kumar Singh", "Manjula Singamsetty", "Sudhakar M", "Mandeep Singh", "Mohammad Wasif Ansari", "Parimal Paritosh"]
  },
  {
    category: "Pravartak Award",
    id: "U1UCI077",
    domain: "Well Services, Western Offshore",
    title: "AI/ML Based Candidate Well Selection for Well Intervention",
    team: ["Sohil Shah", "Alok Verma", "Kaushala Agrawala"]
  },
  {
    category: "Champion Award",
    id: "U2UCI301",
    domain: "G&G, KG Basin, IRS",
    title: "De-Risking Field Development via AI/ML Driven Petrophysical Rock Typing",
    team: ["Sanjoy Das", "Sabyasachi Bhowmick", "Shashi Kumar Suman", "Shubham Gupta", "Kitho Stephen", "Neerudu Ragalbande", "Malini Chakraborty"]
  },
  {
    category: "Champion Award",
    id: "U2UCI307",
    domain: "Drilling, Rajahmundry Asset | IDWE, Dehradun",
    title: "DRISHTI: Drilling with Real-time Intelligent Systems for Holistic & Timely Interventions",
    team: ["Vinod Kanobaji Zile", "Shailesh Chandra Sinha", "Bala Saidulu Nallagondla", "Rajjan Singh Thakur", "Santosh Kumar Gupta", "Ramu Pedumajji", "Pankaj Kumar", "Murugesan M K", "N Harish", "Krishna Reddy"]
  },
  {
    category: "1st Runner-Up Award",
    id: "U2UCI093",
    domain: "Well Services Delhi",
    title: "AI-Driven Economic Gatekeeping for Workover Jobs",
    team: ["Devendra Kumar Aggarwal", "Nirmal Kumar Mishra", "Sugata Guchhait", "Praveen Kumar Jha", "Vishal Kumar", "Prateek Gupta", "Brijbhushan Ahuja"]
  },
  {
    category: "1st Runner-Up Award",
    id: "U1UCI080",
    domain: "Drilling, RCC Chennai",
    title: "Real-Time Pore Pressure Prediction using AI for Drilling Safety",
    team: ["Jagannath Chaudhary", "Lakshman Katherla", "K Praveen Kumar", "V L L Krishnaveni Emani", "Santosh Kumar Gupta"]
  },
  {
    category: "1st Runner-Up Award",
    id: "U2UCI362",
    domain: "Process Plant, Rajahmundry",
    title: "ML-Based Refinery Profit Optimisation & Quality Assurance",
    team: [
      { name: "Santanu Das", role: "Team Mentor" },
      { name: "Mudavath Priyatham Naik", role: "Team Lead" },
      { name: "Amit Kumar", role: "Programming Lead" },
      { name: "Rahman A M", role: "Project Manager" },
      { name: "Shubhendu Sharan Gupta", role: "Team Member" },
      { name: "Hrushikesh Reddy", role: "Technical Lead" },
      { name: "Prafful Mittal", role: "Team Member" },
      { name: "Suryamani Kumar", role: "Team Member" },
      { name: "Koushik Mondal", role: "Quality Control" },
      { name: "CH Deepank", role: "Team Member" }
    ]
  },
  {
    category: "2nd Runner-Up Award",
    id: "U2UCI447",
    domain: "Business Process, A&AA Basin",
    title: "TATHYA AI: Validate. Enrich. Decide",
    team: ["Sarabjeet Singh Dhanjal", "Sudhir Sharma", "Mandeep Singh", "Vinay Sahu"]
  },
  {
    category: "2nd Runner-Up Award",
    id: "U2UCI126",
    domain: "Business Process, GEOPIC",
    title: "Secure On-Premises Smart OCR for Enterprise Data Management",
    team: ["Nebula Bagchi", "Davinder Singh", "Prashant K Dubey", "Venkatesh P", "Santosh Kumar Sahu", "Suresh Konka", "Satya Narayan", "Nikhil Singh", "Neha Pandey"]
  },
  {
    category: "2nd Runner-Up Award",
    id: "U2UCI234",
    domain: "Finance, Ahmedabad",
    title: "aiRR: AI Assisted IRR & Risk Framework for Optimal Well Drilling & Cost Efficiency",
    team: ["Satish Kumar", "Satish Chandra Gupta", "Bhargab Goswami", "Hemasundara Rao Kambala", "Raghvendra Sharma"]
  },
  {
    category: "2nd Runner-Up Award",
    id: "U2UCI376",
    domain: "Production, Rajahmundry",
    title: "ML-Driven Well Flow Cycle Optimization",
    team: ["Jayant Kumar", "Vishal Mittal", "Hrushikesh Reddy", "Rahman A M", "Mudavath Priyatham Naik", "Vaibhav Kumar Lakra", "Shubhendu Sharan Gupta", "Pankaj Kumar", "Veluri Raviteja"]
  },
  {
    category: "Special Jury Award",
    id: "U2UCI038",
    domain: "HSSE, Corporate HSE",
    title: "A Centralised HSE Ranking System to Assess Safety Performance of Business Units",
    team: ["Pawan Kumar Jalutharia", "Arshad Hussain", "Alka Yadav", "Jayashree Prusty", "Paul Mickey Toppo", "Prem Prakash Hansda", "Vivek Singh"]
  },
  {
    category: "Special Jury Award",
    id: "U2UCI424",
    domain: "Artificial Lift, Mehsana",
    title: "AI-Enabled Dynacard Fault Diagnosis for SRP Well",
    team: ["Sagun Devshali", "Deepak Gunwant", "Jitendra Dadhich", "Rajjan Singh Thakur"]
  },
  {
    category: "Special Jury Award",
    id: "U2UCI290",
    domain: "Pipeline, Mumbai",
    title: "AI-Based Virtual Inline Inspection (V-ILI) for Predictive Pipeline Integrity",
    team: ["Neeraj Kumar", "Rajiv Vasisth", "Peter Vaddi", "Pamini BN"]
  },
  {
    category: "Insight to Impact Award",
    id: "U2UCI232",
    domain: "Drilling, Rajahmundry",
    title: "SmartChem: Smart Inventory Management and Forecasting",
    team: ["Mathialagan P", "Vishal Mittal", "Ramu Pedumajji", "Rajjan S. Thakur", "Santosh K. Gupta", "Bala Saidulu Nallagondla", "Pankaj Kumar", "Murugesan M K", "N Harish", "Krishna Reddy"]
  },
  {
    category: "Sustainable Operations Award",
    id: "U2UCI255",
    domain: "Process Plant, Rajahmundry",
    title: "ML-Driven H₂S Elimination in Gas Pipelines and Strategic Reduction of Non-Eco Friendly Chemical Usage Across ONGC Installations",
    team: ["BSS Kumar", "Rahman A M", "Sushant Gupta", "Hrushikesh Reddy", "Mudavath Priyatham Naik", "Jeetendra Bobanga", "Koushik Mondal", "Deepak Kumar Vishwakarma"]
  },
  {
    category: "AI Technology Award",
    id: "U2UCI414",
    domain: "G&G, Western Offshore Basin",
    title: "Unlocking the Deep-water Frontier: AI-Driven Lithofacies Discrimination",
    team: ["Prosenjit Das", "G. Parthiban", "Sayandeep Roy", "Ayan K. Mondal", "Umang Nagpal"]
  },
  {
    category: "Asset Reliability Excellence Award",
    id: "U2UCI249",
    domain: "Artificial Lift, NH Asset Mumbai",
    title: "ESP-360: Real-Time Failure & Residual Equipment Life Prediction Using AI",
    team: ["Manoj Mishra", "Choppala Satya Tej", "Manoj Mehta", "Saksham Gupta", "Ashish Saini", "Ashutosh Pathak", "Bhavishy K Gupta"]
  },
  {
    category: "AI Adoption Trailblazer Award",
    id: "U2UCI052",
    domain: "Well Services, Ahmedabad",
    title: "AI/ML Based Workover Rig Scheduling and Candidate Well Selection",
    team: ["Kaushal Agrawala", "Sohil Shah", "Alok Verma", "Harini L"]
  },
  {
    category: "Workforce Safety Innovation Award",
    id: "U2UCI395",
    domain: "HSSE, Mehsana",
    title: "AI-Based Real-Time PPE Compliance Monitoring System",
    team: ["Shrishti Awasthi"]
  },
  {
    category: "Smart Engineering Award",
    id: "U2UCI239",
    domain: "G&G, Frontier Basin, Dehradun",
    title: "ML-Based Optimisation of Uphole Surveys in Onshore Seismic Data Acquisition",
    team: ["Manav Kumar", "Sh Bronson Aimol", "Saswata Bag", "Dharmendra Kumar"]
  },
  {
    category: "Digital Transformation Starter Award",
    id: "U2UCI364",
    domain: "G&G, SPIC Mumbai",
    title: "AI-Enabled Unified Block Intelligence System for Upstream Data Lineage",
    team: ["Ramkaran Singh", "Rupjyoti Dutta", "Jainendra Srivastava", "Bhairav Changkakoty", "Rakesh Kumar Yadav", "Umang Nagpal", "Kalaiselvi S.", "Brijesh K. Pandey", "Piyush Nayal", "Pawan Singh", "Hardeep P.", "Abhishek Bisui", "Rehan Ansari", "Dipankan S."]
  },
  {
    category: "Ground Truth Innovator Award",
    id: "U2UCI413",
    domain: "HSSE, Assam Asset",
    title: "Utilization of Drilling Cuttings for Internal Road Laying and Civil Works",
    team: ["V. Sreedher", "Nainesh B Shah", "Haritha Maddi", "Roshan P Koshy"]
  },
  {
    category: "Operational Impact Award",
    id: "U2UCI428",
    domain: "Process Plant, Ahmedabad",
    title: "GGS Management App and Portal (GAMIJ)",
    team: ["Sonu Kumar Singh", "Sukumar Laha", "Ravi K. Sharma", "Alpesh Parmar"]
  },
  {
    category: "Paradigm Breaker Award",
    id: "U2UCI021",
    domain: "Reservoir, Mehsana",
    title: "Use of Artificial Intelligence in Well-Test Interpretation",
    team: ["Abhineet Baruah", "Sabyasachi Saikia", "Arnav", "Anamika Gahlot", "Adarsh Tripathi", "Aamir Iqbal"]
  },
  {
    category: "Knowledge Excellence Award",
    id: "U2UCI444",
    domain: "IT, Corporate Infocom Office",
    title: "AI-Enabled Digital Repository for MVT and Safety Competency Certificates",
    team: ["Manish Kumar", "Anshu Kumar", "Joseph Mattamana", "Nirmal Kuma Misha", "Gomati Murugesan"]
  },
  {
    category: "Digital Assurance Award",
    id: "U2UCI445",
    domain: "Audit, Corporate Infocom Office",
    title: "Agentic AI Solution for Automating and Augmenting the Nomination Audit Reports",
    team: ["Pawan Kumar", "Abhay Dongre", "Naveen Kumar", "Santosh Kumar", "Joseph Mattamana", "Sreenath S. Das", "Anshu Kuma"]
  }
];

// ─── Photo map ─────────────────────────────────────────────────────────────
const memberImages = {
  "Manish Kumar": "/team_photos/image139.jpg",
  "Anshu Kumar": "/team_photos/image140.jpg",
  "Joseph Mattamana": "/team_photos/image141.jpg",
  "Sudesh Kakkar": "/team_photos/image142.jpg",
  "Pawan Kumar": "/team_photos/image143.jpg",
  "Sreenath S. Das": "/team_photos/image144.jpg",
  "Aamir Iqbal": "/team_photos/image2.jpg",
  "Anamika Gahlot": "/team_photos/image7.jpg",
  "Amit Kumar": "/team_photos/image111.png",
  "Abhishek Bisui": "/team_photos/image1.jpg",
  "Adarsh Tripathi": "/team_photos/image61.jpg",
  "Alka Yadav": "/team_photos/image55.jpg",
  "Alok Verma": "/team_photos/AlokVerma.jpg",
  "Abhineet Baruah": "/team_photos/image16.jpg",
  "Saksham Gupta": "/team_photos/image28.jpg",
  "Alpesh Parmar": "/team_photos/image85.jpg",
  "-": "/team_photos/image12.jpg",
  "Arnav": "/team_photos/image12.jpg",
  "Veluri Raviteja": "/team_photos/image67.jpg",
  "Ramkaran Singh": "/team_photos/image23.png",
  "Arshad Hussain": "/team_photos/image110.jpg",
  "Ashish Saini": "/team_photos/image30.jpg",
  "Ashutosh Pathak": "/team_photos/image37.jpg",
  "Ayan Kumar Mondal": "/team_photos/image69.jpg",
  "BSS Kumar": "/team_photos/image78.jpg",
  "Bhairav Changkakoty": "/team_photos/image72.jpg",
  "Bhargab Goswami": "/team_photos/image91.jpg",
  "Bhavishy Kumar Gupta": "/team_photos/image47.jpg",
  "Brijbhushan Ahuja": "/team_photos/image98.jpg",
  "Brijesh K. Pandey": "/team_photos/image27.jpg",
  "CH Deepank": "/team_photos/image118.jpg",
  "Choppala Satya Tej": "/team_photos/image26.jpg",
  "Davinder Singh": "/team_photos/image5.jpg",
  "Deepak Gunwant": "/team_photos/image44.jpg",
  "Deepak Kumar Vishwakarma": "/team_photos/image59.jpg",
  "Devendra Kumar Aggarwal": "/team_photos/image46.jpg",
  "Dipankan S.": "/team_photos/image13.jpg",
  "G. Parthiban": "/team_photos/image73.jpg",
  "Hardeep P.": "/team_photos/image34.jpg",
  "Harini L": "/team_photos/image124.jpg",
  "Haritha Maddi": "/team_photos/image8.jpg",
  "Hemasundara Rao Kambala": "/team_photos/image90.jpg",
  "Hrushikesh Reddy": "/team_photos/image131.jpg",
  "Jagannath Chaudhary": "/team_photos/image134.jpg",
  "Jainendra Srivastava": "/team_photos/image74.jpg",
  "Jayant Kumar": "/team_photos/image64.jpg",
  "Jayashree Prusty": "/team_photos/image117.jpg",
  "Jeetendra Bobanga": "/team_photos/image53.jpg",
  "Jitendra Dadhich": "/team_photos/image45.jpg",
  "K Praveen Kumar": "/team_photos/image116.png",
  "Satya Narayan": "/team_photos/image106.jpg",
  "Kalaiselvi S.": "/team_photos/image20.jpg",
  "Kaushal Agrawala": "/team_photos/image123.jpg",
  "Kitho Stephen": "/team_photos/image94.jpg",
  "Koushik Mondal": "/team_photos/image109.jpg",
  "Krishna Reddy": "/team_photos/image81.jpg",
  "Lakshman Katherla": "/team_photos/image113.jpg",
  "Malini Chakraborty": "/team_photos/image10.jpg",
  "Manav Kumar": "/team_photos/image89.jpg",
  "Mandeep Singh": "/team_photos/image21.jpg",
  "Manoj Mehta": "/team_photos/image36.jpg",
  "Manoj Mishra": "/team_photos/image29.jpg",
  "Mudavath Priyatham Naik": "/team_photos/image101.jpg",
  "Murugesan M K": "/team_photos/image39.jpg",
  "N Harish": "/team_photos/image401.jpg",
  "Nainesh B Shah": "/team_photos/image25.jpg",
  "Nebula Bagchi": "/team_photos/image4.jpg",
  "Neeraj Kumar": "/team_photos/image631.jpg",
  "Neerudu Ragalbande": "/team_photos/image95.jpg",
  "Neha Pandey": "/team_photos/image83.jpg",
  "Nikhil Singh": "/team_photos/image84.jpg",
  "Pamini BN": "/team_photos/image57.jpg",
  "Pankaj kumar": "/team_photos/iamegpankj2.png",
  "Pankaj Kumar": "/team_photos/iamegpankj2.png",
  "Rajiv Vasisth": "/team_photos/image129.png",
  "Nirmal Kumar Mishra": "/team_photos/image60.jpg",
  "Vishal Kumar": "/team_photos/image80.jpg",
  "Paul Mickey Toppo": "/team_photos/image115.jpg",
  "Pawan Kumar Jalutharia": "/team_photos/image107.jpg",
  "Pawan Singh": "/team_photos/image3.jpg",
  "Peter Vaddi": "/team_photos/image51.jpg",
  "Piyush Nayal": "/team_photos/image54.jpg",
  "Prafful Mittal": "/team_photos/image127.jpg",
  "Prashant Kumar Dubey": "/team_photos/image6.jpg",
  "Prateek Gupta": "/team_photos/image77.jpg",
  "Praveen Kumar Jha": "/team_photos/image50.jpg",
  "Prem Prakash Hansda": "/team_photos/image114.jpg",
  "Prosenjit Das": "/team_photos/image128.jpg",
  "Raghvendra Sharma": "/team_photos/image88.jpg",
  "Rahman A M": "/team_photos/image130.jpg",
  "Rakesh Kumar Yadav": "/team_photos/image19.jpg",
  "Ravi K. Sharma": "/team_photos/image75.jpg",
  "Rehan Ansari": "/team_photos/image9.jpg",
  "Roshan P Koshy": "/team_photos/image17.jpg",
  "Rupjyoti Dutta": "/team_photos/image24.jpg",
  "Sabyasachi Bhowmick": "/team_photos/image135.jpg",
  "Sabyasachi Saikia": "/team_photos/image151.jpg",
  "Sagun Devshali": "/team_photos/image108.jpg",
  "Sanjoy Das": "/team_photos/image961.jpg",
  "Santanu Das": "/team_photos/image112.jpg",
  "Santosh Kumar Sahu": "/team_photos/image48.jpg",
  "Sarabjeet Singh Dhanjal": "/team_photos/image32.jpg",
  "Satish Chandra Gupta": "/team_photos/image126.jpg",
  "Satish Kumar": "/team_photos/image86.jpg",
  "Saswata Bag": "/team_photos/image102.png",
  "Dharmendra Kumar": "/team_photos/image65.png",
  "Sayandeep Roy": "/team_photos/image76.jpg",
  "Sh Bronson Aimol": "/team_photos/image58.jpg",
  "Shailesh Chandra Sinha": "/team_photos/image35.jpg",
  "Shashi Kumar Suman": "/team_photos/image97.jpg",
  "Shrishti Awasthi": "/team_photos/image68.jpg",
  "Shubham Gupta": "/team_photos/image93.jpg",
  "Shubhendu Sharan Gupta": "/team_photos/image132.jpg",
  "Sohil Shah": "/team_photos/sohilShah.jpg",
  "Sonu Kumar Singh": "/team_photos/image71.jpg",
  "Sudhir Sharma": "/team_photos/image22.jpg",
  "Sugata Guchhait": "/team_photos/image42.jpg",
  "Sukumar Laha": "/team_photos/image92.jpg",
  "Suresh Konka": "/team_photos/image15.jpg",
  "Suryamani Kumar": "/team_photos/image133.jpg",
  "Sushant Gupta": "/team_photos/image79.jpg",
  "Umang Nagpal": "/team_photos/image18.jpg",
  "V L L Krishnaveni Emani": "/team_photos/image122.jpg",
  "V. Sreedher": "/team_photos/image11.jpg",
  "Vaibhav Kumar Lakra": "/team_photos/image104.jpg",
  "Venkatesh P": "/team_photos/image14.jpg",
  "Vinay Sahu": "/team_photos/image31.jpg",
  "Vinod Kanobaji Zile": "/team_photos/image56.jpg",
  "Vishal Mittal": "/team_photos/image103.jpg",
  "Vivek Singh": "/team_photos/image120.jpg",
  "Santosh Kumar": "/team_photos/image48.jpg",
  "Abhay Dongre": "/team_photos/image10.jpg",
  "Aninda Ghosh": "/team_photos/imageanil.png",
  "Anil Thapliyal": "/team_photos/imageaninda.png",
  "Naveen Kumar M": "/team_photos/imagerakesh.png",
  "Rakesh Sarkar": "/team_photos/imagenaveen.png",
  "Pratik R Kumawat": "/team_photos/imagearang.png",
  "A Rangaswamy": "/team_photos/imagepreteek.png",
  "Smitha NC": "/team_photos/image332.png",
  "Sanjai Kumar Singh": "/team_photos/imagemanju.png",
  "Manjula Singamsetty": "/team_photos/image223.png",
  "Sudhakar M": "/team_photos/imagesmitha.png",
  "Mandeep Singh": "/team_photos/imageparima.png",
  "Mohammad Wasif Ansari": "/team_photos/imagemohammad.png",
  "Parimal Paritosh": "/team_photos/imagemandeep.png",
  "Prashant K Dubey": "/team_photos/imageprashant.png",
  "Rajjan S. Thakur": "/team_photos/imagesantosh.png",
  "Santosh K. Gupta": "/team_photos/imagesantosh2.png",
  "Ayan K. Mondal": "/team_photos/imageayan.png",
  "Bhavishy K Gupta": "/team_photos/imagebhavishy.png",
  "Nirmal Kuma Misha": "/team_photos/imagenirmal.png",
  "Gomati Murugesan": "/team_photos/imagegomati.png",
  "Naveen Kumar": "/team_photos/imagenaveen2.png",
  "Anshu Kuma": "/team_photos/iamgeanshu.png",
  "Bala Saidulu Nallagondla": "/team_photos/imageramu.png",
  "Rajjan Singh Thakur": "/team_photos/imagesantosh.png",
  "Ramu Pedumajji": "/team_photos/imagerajjan.png",
  "Janeshwar Prasad": "/team_photos/imagejaneshwar.png",
  "Raghu Ottoor Menon": "/team_photos/imagemathialagan.png",
  "Mathialagan P": "/team_photos/imageraghu.png",
  "Santosh Kumar Gupta": "/team_photos/imagesantosh2.png",
  "Srinivasan J": "/team_photos/imagesrinivasan.png",
  "Kaushala Agrawala": "/team_photos/kaushalaAgrawala.jpg",

};

const memberImagesByWinnerId = {
  U2UCI376: {
    "Pankaj Kumar": "/team_photos/pankajKumar.png",
  },
};

function getPhoto(name, winnerId) {
  const path = memberImagesByWinnerId[winnerId]?.[name] || memberImages[name];
  return path ? `/images${path}` : null;
}

// ─── Avatar ────────────────────────────────────────────────────────────────
function Avatar({ name, winnerId, size = 110 }) {
  const [imgError, setImgError] = useState(false);
  const src = getPhoto(name, winnerId);
  const initials = name ? name.split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase() : "?";

  const baseStyle = {
    width: size,
    height: size,
    minWidth: size,
    flexShrink: 0,
    borderRadius: "50%",
    border: "3px solid #4ade80",
    boxShadow: "0 0 12px rgba(74, 222, 128, 0.4)",
    overflow: "hidden",
  };

  if (src && !imgError) {
    return (
      <img
        src={src}
        alt={name}
        onError={() => setImgError(true)}
        style={{
          ...baseStyle,
          objectFit: "cover",
          backgroundColor: "#08130e",
          display: "block",
        }}
      />
    );
  }

  return (
    <div style={{
      ...baseStyle,
      background: "linear-gradient(135deg, #0d2016 0%, #0a1a10 100%)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: size * 0.33,
      fontWeight: 700,
      color: "#4ade80",
      letterSpacing: "0.04em",
    }}>
      {initials}
    </div>
  );
}

// ─── Domain color map ──────────────────────────────────────────────────────
const domainColors = {
  "G&G": { bg: "rgba(139,92,246,0.12)", text: "#a78bfa", border: "rgba(139,92,246,0.25)" },
  "Drilling": { bg: "rgba(251,146,60,0.12)", text: "#fb923c", border: "rgba(251,146,60,0.25)" },
  "Process Plant": { bg: "rgba(16,185,129,0.12)", text: "#34d399", border: "rgba(16,185,129,0.25)" },
  "Well Services": { bg: "rgba(59,130,246,0.12)", text: "#60a5fa", border: "rgba(59,130,246,0.25)" },
  "Finance": { bg: "rgba(234,179,8,0.12)", text: "#facc15", border: "rgba(234,179,8,0.25)" },
  "Reservoir": { bg: "rgba(20,184,166,0.12)", text: "#2dd4bf", border: "rgba(20,184,166,0.25)" },
  "Artificial Lift": { bg: "rgba(244,63,94,0.12)", text: "#fb7185", border: "rgba(244,63,94,0.25)" },
  "Business Process": { bg: "rgba(99,102,241,0.12)", text: "#818cf8", border: "rgba(99,102,241,0.25)" },
  "HSSE": { bg: "rgba(239,68,68,0.12)", text: "#f87171", border: "rgba(239,68,68,0.25)" },
  "Production": { bg: "rgba(34,197,94,0.12)", text: "#4ade80", border: "rgba(34,197,94,0.25)" },
  "Pipeline": { bg: "rgba(14,165,233,0.12)", text: "#38bdf8", border: "rgba(14,165,233,0.25)" },
  "IT": { bg: "rgba(217,70,239,0.12)", text: "#d946ef", border: "rgba(217,70,239,0.25)" },
  "Audit": { bg: "rgba(132,204,22,0.12)", text: "#84cc16", border: "rgba(132,204,22,0.25)" },
};

function getDomainStyle(domainRaw) {
  const domain = domainRaw.split(",")[0].trim();
  return domainColors[domain] || { bg: "rgba(255,255,255,0.06)", text: "#9ca3af", border: "rgba(255,255,255,0.12)" };
}

// ─── Member pill (compact) ────────────────────────────────────────────────
function MemberPill({ member, winnerId }) {
  const name = typeof member === 'string' ? member : member.name;
  let role = typeof member === 'string' ? null : member.role;
  if (role === "Team Member" || role === "Team Mentor" || role === "Mentor") role = null;
  const isLead = typeof role === 'string' && role.startsWith("Team Lead");

  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "10px",
      padding: "12px 6px",
      width: "100%",
      textAlign: "center",
    }}>
      <Avatar name={name} winnerId={winnerId} size={110} />
      <div style={{ width: "100%" }}>
        <div style={{ fontSize: "1.1rem", fontWeight: 700, color: "#e5e7eb", lineHeight: 1.25, whiteSpace: "normal", wordWrap: "break-word" }}>
          {name}
        </div>
        {role && (
          <div style={{ fontSize: "0.95rem", color: isLead ? "#10b981" : "#9ca3af", fontWeight: isLead ? 700 : 400, fontStyle: "italic", marginTop: "4px", lineHeight: 1.25, whiteSpace: "normal", wordWrap: "break-word" }}>
            {role}
          </div>
        )}
      </div>
    </div>
  );
}

// ─── Winner Team Card ─────────────────────────────────────────────────────────────
function WinnerTeamCard({ category, id, domain, title, team }) {
  const [domainRaw, locationRaw] = domain.split(",");
  const domainName = domainRaw.trim();
  const location = locationRaw ? locationRaw.trim() : "";
  const ds = getDomainStyle(domainName);

  return (
    <div style={{
      background: "#0a0a0a",
      border: "1px solid #1a1a1a",
      borderRadius: "14px",
      overflow: "hidden",
      transition: "border-color 0.25s ease, box-shadow 0.25s ease",
      height: "100%",
      display: "flex",
      flexDirection: "column",
    }}
      onMouseEnter={(e) => {
        e.currentTarget.style.borderColor = "rgba(16,185,129,0.3)";
        e.currentTarget.style.boxShadow = "0 6px 24px rgba(0,0,0,0.4)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.borderColor = "#161b22";
        e.currentTarget.style.boxShadow = "none";
      }}
    >
      {/* Accent bar */}
      <div style={{
        height: "4px", background: category.includes("Pravartak") ? "linear-gradient(to right, #f59e0b, #fbbf24)"
          : category.includes("Champion") ? "linear-gradient(to right, #3b82f6, #60a5fa)"
            : "linear-gradient(to right, #10b981, #34d399)"
      }} />

      <div style={{ padding: "24px 22px", display: "flex", flexDirection: "column", gap: "16px", flex: 1 }}>

        {/* Top row: domain badge + id + location */}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: "8px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <span style={{
              fontSize: "0.72rem",
              fontWeight: 700,
              padding: "3px 9px",
              borderRadius: "5px",
              background: ds.bg,
              color: ds.text,
              border: `1px solid ${ds.border}`,
              letterSpacing: "0.03em",
            }}>
              {domainName}
            </span>
            {location && (
              <>
                <span style={{ fontSize: "0.75rem", color: "#d1d5db" }}>·</span>
                <span style={{ fontSize: "0.75rem", color: "#d1d5db" }}>{location}</span>
              </>
            )}
          </div>
          <span style={{ fontSize: "0.75rem", fontWeight: 700, color: "#10b981", fontFamily: "monospace", letterSpacing: "0.04em" }}>
            {id}
          </span>
        </div>

        {/* Category Label */}
        {category && !category.includes("Other Award") && (
          <div style={{ display: 'flex', width: '100%', marginBottom: '4px' }}>
            <span style={{
              background: category.includes("Pravartak") ? "rgba(245, 158, 11, 0.12)" : category.includes("Champion") ? "rgba(59, 130, 246, 0.12)" : "rgba(16, 185, 129, 0.12)",
              color: category.includes("Pravartak") ? "#fbbf24" : category.includes("Champion") ? "#60a5fa" : "#34d399",
              padding: "5px 12px",
              borderRadius: "8px",
              fontSize: "0.85rem",
              fontWeight: "600",
              border: `1px solid ${category.includes("Pravartak") ? "rgba(245, 158, 11, 0.25)" : category.includes("Champion") ? "rgba(59, 130, 246, 0.25)" : "rgba(16, 185, 129, 0.25)"}`,
              letterSpacing: "0.02em",
              display: "flex",
              alignItems: "center",
              gap: "6px"
            }}>
              <span>🏆</span> {category}
            </span>
          </div>
        )}

        {/* Title */}
        <h3 style={{
          fontSize: "1.15rem",
          fontWeight: 700,
          background: "linear-gradient(135deg, #4ade80 0%, #34d399 50%, #f87171 100%)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
          lineHeight: 1.45,
          margin: 0,
        }}>
          {title}
        </h3>

        {/* Team Members row */}
        <div style={{ marginTop: "auto", paddingTop: "16px" }}>
          <div style={{ fontSize: "0.68rem", fontWeight: 600, color: "#d1d5db", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: "8px" }}>
            Team Members
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6">
            {team.map((m, i) => (
              <MemberPill key={i} member={m} winnerId={id} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default function Winners() {
  const [visible, setVisible] = useState(false);
  const [showScroll, setShowScroll] = useState(false);
  const [returnScrollPos, setReturnScrollPos] = useState(0);
  const [searchParams, setSearchParams] = useSearchParams();
  const teamParam = searchParams.get("team");

  const shrishtiTeam = winnersData.find(w => w.id === "U2UCI395");
  const rahmanTeamData = winnersData.find(w => w.id === "U2UCI362");

  const rahmanTeam = rahmanTeamData ? {
    ...rahmanTeamData,
    team: rahmanTeamData.team.filter(member => {
      const name = typeof member === 'string' ? member : member.name;
      return name === "Rahman A M";
    })
  } : null;

  const selectedTeam = teamParam === "rahman" 
    ? rahmanTeam 
    : teamParam === "shrishti" 
      ? shrishtiTeam 
      : teamParam 
        ? winnersData.find(w => w.id === teamParam) 
        : null;

  const setSelectedTeam = (winner) => {
    if (winner) {
      let paramId = winner.id;
      if (winner === rahmanTeam) paramId = "rahman";
      if (winner === shrishtiTeam) paramId = "shrishti";
      
      const newParams = new URLSearchParams(searchParams);
      newParams.set("team", paramId);
      setSearchParams(newParams);
    } else {
      const newParams = new URLSearchParams(searchParams);
      newParams.delete("team");
      setSearchParams(newParams, { replace: true });
    }
  };

  useEffect(() => { setTimeout(() => setVisible(true), 100); }, []);

  useEffect(() => {
    const checkScrollTop = () => {
      if (!showScroll && window.pageYOffset > 400) {
        setShowScroll(true);
      } else if (showScroll && window.pageYOffset <= 400) {
        setShowScroll(false);
      }
    };
    window.addEventListener('scroll', checkScrollTop);
    return () => window.removeEventListener('scroll', checkScrollTop);
  }, [showScroll]);

  const scrollBack = () => {
    if (returnScrollPos > 0) {
      window.scrollTo({ top: returnScrollPos, behavior: 'smooth' });
      setReturnScrollPos(0);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const navigate = useNavigate();
  const location = useLocation();

  const [searchQuery, setSearchQuery] = useState("");

  const filteredWinnersData = winnersData.filter(winner => {
    const query = searchQuery.toLowerCase();
    const matchesTitle = winner.title?.toLowerCase().includes(query) || false;
    const matchesDomain = winner.domain?.toLowerCase().includes(query) || false;
    const matchesCategory = winner.category?.toLowerCase().includes(query) || false;
    const matchesTeam = winner.team?.some(member => {
      const name = typeof member === 'string' ? member : member.name;
      return name?.toLowerCase().includes(query);
    }) || false;
    return matchesTitle || matchesDomain || matchesCategory || matchesTeam;
  });

  const activeTab = location.pathname === "/article"
    ? "article"
    : location.pathname === "/shortlisted"
      ? "shortlisted"
      : location.pathname === "/finalists"
        ? "finalists"
        : location.pathname === "/winners"
          ? "winners"
          : "submission-insights";

  const handleTabClick = (tab) => {
    if (tab === "article") navigate("/article");
    else if (tab === "shortlisted") navigate("/shortlisted");
    else if (tab === "finalists") navigate("/finalists");
    else if (tab === "winners") navigate("/winners");
    else navigate("/submission-insights");
  };

  const ImageComponent = ({ src, alt, style, className }) => (
    <img src={src} alt={alt} style={{ maxWidth: "100%", height: "auto", borderRadius: "8px", ...style }} className={className} />
  );

  // ─── Modal Team Component ─────────────────────────────────────────────────────────────
  const TeamModal = ({ winner, onClose }) => {
    if (!winner) return null;
    return (
      <div style={{
        position: 'fixed',
        top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.85)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        padding: '20px',
        backdropFilter: 'blur(4px)'
      }} onClick={onClose}>
        <button onClick={onClose} style={{
          position: 'absolute',
          top: '24px',
          right: '32px',
          background: 'rgba(0,0,0,0.6)',
          border: '1px solid rgba(255,255,255,0.3)',
          borderRadius: '50%',
          width: '40px',
          height: '40px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#fff',
          fontSize: '1.2rem',
          cursor: 'pointer',
          zIndex: 10000,
          transition: 'background 0.2s'
        }}
          onMouseOver={(e) => e.currentTarget.style.background = 'rgba(255,255,255,0.2)'}
          onMouseOut={(e) => e.currentTarget.style.background = 'rgba(0,0,0,0.6)'}
        >✕</button>

        <div className="custom-scrollbar" style={{
          maxWidth: '900px',
          width: '100%',
          position: 'relative',
          maxHeight: '90vh',
          overflowY: 'auto',
          borderRadius: '14px',
          boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.5), 0 10px 10px -5px rgba(0, 0, 0, 0.3)'
        }} onClick={e => e.stopPropagation()}>
          <WinnerTeamCard {...winner} />
        </div>
      </div>
    );
  };

  // ─── Clickable Team Card ─────────────────────────────────────────────────────────────
  const ClickableTeamCard = ({ winner, onClick }) => {
    const teamNames = {
      "U1UCI512": "Team Optiinject",
      "U1UCI345": "Team Drishti",
      "U1UCI077": "Team WellEx",
      "U1UCI013": "Team GeoPulse",
      "U2UCI301": "Team Subsurface Investigators",
      "U2UCI307": "Team Drishti 2.0",
      "U2UCI093": "Team Arth Rakshak",
      "U1UCI080": "Team EarthHackers",
      "U2UCI362": "Team Tatipaka Stars",
      "U2UCI447": "Team DataMiners",
      "U2UCI126": "Team ONGC OCR",
      "U2UCI234": "Team AiRR",
      "U2UCI376": "Team Production Optimizers",
      "U2UCI038": "Team NEUROGRID",
      "U2UCI424": "Team RodBotics",
      "U2UCI290": "Team Virtual ILI Pioneers",
      "U2UCI232": "Drishti 2.0",
      "U2UCI255": "H2S Scavengers 2.0",
      "U2UCI414": "Fort Kochi",
      "U2UCI249": "ESP Sentinels",
      "U2UCI052": "RigEx",
      "U2UCI395": "Suraksha Netra",
      "U2UCI239": "Geo-Crackers",
      "U2UCI364": "Data Avengers",
      "U2UCI413": "ECOPAVERS",
      "U2UCI428": "GAMIJ",
      "U2UCI021": "Alpha",
      "U2UCI444": "SafeCert AI",
      "U2UCI445": "Sentinel AI"
    };

    const displayName = teamNames[winner.id] || "Team";

    return (
      <div
        onClick={() => onClick(winner)}
        className="flex flex-col sm:flex-row h-full"
        style={{
          background: "#fff",
          color: "#000",
          cursor: "pointer",
          borderRadius: "8px",
          overflow: "hidden",
          boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
          transition: "transform 0.2s, box-shadow 0.2s",
          border: "1px solid #e5e7eb"
        }}
        onMouseOver={(e) => {
          e.currentTarget.style.transform = "translateY(-4px)";
          e.currentTarget.style.boxShadow = "0 8px 15px rgba(0,0,0,0.2)";
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "0 4px 6px rgba(0,0,0,0.1)";
        }}
      >
        <div className="w-full sm:w-[120px]" style={{
          background: "#fbbf24", // yellow-400
          padding: "16px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          flexShrink: 0,
          textAlign: "center"
        }}>
          <div style={{ fontWeight: 800, fontSize: "1.1rem", lineHeight: 1.2, marginBottom: "8px" }}>
            {displayName}
          </div>
          <div style={{ fontSize: "0.75rem", fontWeight: 700, color: "#111827" }}>
            {winner.id}
          </div>
        </div>
        <div style={{
          padding: "16px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          flex: 1,
        }}>
          <div className="text-center sm:text-left justify-center sm:justify-start" style={{
            fontSize: "0.95rem",
            fontWeight: 600,
            lineHeight: 1.4,
            marginBottom: "8px",
            flex: 1,
            display: "flex",
            alignItems: "center"
          }}>
            {winner.title}
          </div>
          <div className="justify-center sm:justify-end" style={{
            fontSize: "0.75rem",
            color: "#6b7280",
            fontWeight: 600,
            textAlign: "right",
            display: "flex",
            alignItems: "center",
            gap: "4px",
            textTransform: "uppercase",
            letterSpacing: "0.05em"
          }}>
            Click to view team <span style={{ fontSize: "0.9rem", color: "#10b981" }}>↗</span>
          </div>
        </div>
      </div>
    );
  };

  // ─── Award Category Box ─────────────────────────────────────────────────────────────
  const AwardCategoryBox = ({ title, subtitle, children }) => (
    <div style={{
      background: "#fbbf24",
      borderRadius: "16px",
      padding: "2px", // border thickness
      marginBottom: "32px",
      boxShadow: "0 10px 25px rgba(0,0,0,0.4)"
    }}>
      <div style={{
        background: "#fbbf24",
        color: "#000",
        padding: "24px",
        textAlign: "center",
        borderTopLeftRadius: "14px",
        borderTopRightRadius: "14px",
      }}>
        <h2 style={{ fontSize: "2rem", fontWeight: 900, margin: 0, color: "#000" }}>{title}</h2>
        {subtitle && <p style={{ margin: "8px 0 0 0", fontSize: "1.05rem", fontWeight: 600, color: "#1f2937" }}>{subtitle}</p>}
      </div>
      <div style={{
        background: "#f9fafb", // very light gray/white
        borderBottomLeftRadius: "14px",
        borderBottomRightRadius: "14px",
        padding: "24px",
      }}>
        {children}
      </div>
    </div>
  );

  const IndividualCategoryBox = ({ title, children }) => (
    <div style={{
      border: "2px solid #fbbf24",
      borderRadius: "12px",
      overflow: "hidden",
      height: "100%",
      display: "flex",
      flexDirection: "column"
    }}>
      <div style={{ background: "#fbbf24", color: "#000", padding: "12px", textAlign: "center", fontWeight: 800, fontSize: "1.1rem" }}>
        {title}
      </div>
      <div style={{ background: "#fff", padding: "16px", flex: 1, display: "flex", flexDirection: "column", gap: "16px" }}>
        {children}
      </div>
    </div>
  );

  const pravartakWinners = filteredWinnersData.filter(w => w.category.includes("Pravartak"));
  const championWinners = filteredWinnersData.filter(w => w.category === "Champion Award");
  const firstRunnerUpWinners = filteredWinnersData.filter(w => w.category === "1st Runner-Up Award");
  const secondRunnerUpWinners = filteredWinnersData.filter(w => w.category === "2nd Runner-Up Award");
  const specialJuryWinners = filteredWinnersData.filter(w => w.category === "Special Jury Award");

  const individualCategories = [
    "Insight to Impact Award",
    "Sustainable Operations Award",
    "AI Technology Award",
    "Asset Reliability Excellence Award",
    "AI Adoption Trailblazer Award",
    "Workforce Safety Innovation Award",
    "Smart Engineering Award",
    "Digital Transformation Starter Award",
    "Ground Truth Innovator Award",
    "Operational Impact Award",
    "Paradigm Breaker Award",
    "Knowledge Excellence Award",
  ];

  return (
    <div style={{
      fontFamily: "system-ui, -apple-system, sans-serif",
      background: "#000000",
      color: "#e8f5e9",
      minHeight: "100vh",
      overflowX: "hidden",
    }}>
      <style>{`
        .custom-scrollbar::-webkit-scrollbar {
          width: 8px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: rgba(255, 255, 255, 0.05);
          border-radius: 10px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: rgba(255, 255, 255, 0.2);
          border-radius: 10px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: rgba(255, 255, 255, 0.4);
        }
      `}</style>
      {/* Modal for Team Details */}
      <TeamModal winner={selectedTeam} onClose={() => setSelectedTeam(null)} />

      {/* HERO HEADER WITH TABS */}
      <header style={{
        padding: "20px 16px 24px",
        marginTop: "80px",
        minHeight: "auto",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        position: "relative",
        background: "#000000",
        borderBottom: "1px solid #1a1a1a",
      }}>
        {/* Tabs Navigation */}
        <div className="flex justify-center mb-2 w-full">
          <div className="flex flex-col sm:flex-row gap-2 bg-white/5 p-2 sm:p-1 rounded-2xl sm:rounded-full border border-white/10 w-[92%] sm:w-fit">
            <button
              onClick={() => handleTabClick("submission-insights")}
              className={`flex-1 whitespace-nowrap px-4 sm:px-6 py-2.5 sm:py-2 text-sm font-semibold rounded-full transition-all duration-200 ${activeTab === "submission-insights"
                ? "bg-green-500 text-black shadow-md"
                : "text-gray-300 hover:text-white hover:bg-white/10"
                }`}
            >
              Submission Insights
            </button>

            <button
              onClick={() => handleTabClick("article")}
              className={`flex-1 whitespace-nowrap px-4 sm:px-6 py-2.5 sm:py-2 text-sm font-semibold rounded-full transition-all duration-200 ${activeTab === "article"
                ? "bg-green-500 text-black shadow-md"
                : "text-gray-300 hover:text-white hover:bg-white/10"
                }`}
            >
              Evaluation Insights And Result
            </button>

            <button
              onClick={() => handleTabClick("shortlisted")}
              className={`flex-1 whitespace-nowrap px-4 sm:px-6 py-2.5 sm:py-2 text-sm font-semibold rounded-full transition-all duration-200 ${activeTab === "shortlisted"
                ? "bg-green-500 text-black shadow-md"
                : "text-gray-300 hover:text-white hover:bg-white/10"
                }`}
            >
              Shortlisted Use Cases
            </button>

            <button
              onClick={() => handleTabClick("finalists")}
              className={`flex-1 whitespace-nowrap px-4 sm:px-6 py-2.5 sm:py-2 text-sm font-semibold rounded-full transition-all duration-200 ${activeTab === "finalists"
                ? "bg-green-500 text-black shadow-md"
                : "text-gray-300 hover:text-white hover:bg-white/10"
                }`}
            >
              Meet the Finalists
            </button>

            <button
              onClick={() => handleTabClick("winners")}
              className={`flex-1 whitespace-nowrap px-4 sm:px-6 py-2.5 sm:py-2 text-sm font-semibold rounded-full transition-all duration-200 ${activeTab === "winners"
                ? "bg-green-500 text-black shadow-md"
                : "text-gray-300 hover:text-white hover:bg-white/10"
                }`}
            >
              Meet the Winners
            </button>
          </div>
        </div>

        {/* IMAGE #1 - HEADER BANNER (Moved) */}
        <div style={{ width: "100%", maxWidth: "900px", marginBottom: "24px", textAlign: "center" }}>
          <ImageComponent src="/images/extracted_images/image176.jpg" alt="Udbhav Banner" className="h-auto md:h-[490px]" style={{ width: "100%", objectFit: "cover", borderRadius: "12px", boxShadow: "0 4px 20px rgba(0,0,0,0.5)" }} />
        </div>

        <h1 className="text-2xl sm:text-3xl md:text-4xl font-extrabold mb-4 sm:mb-6 bg-gradient-to-r from-green-400 via-emerald-400 to-red-400 bg-clip-text text-transparent tracking-tight leading-tight text-center max-w-[900px] mx-auto">
          From Idea to Impact: Udbhav 2.0 Writes Its Final Chapter
        </h1>
      </header>

      {/* MAIN CONTENT AREA */}
      <main style={{
        maxWidth: "1100px",
        margin: "0 auto",
        padding: "0 16px",
        background: "#000000",
      }}>
        {/* Intro Section */}
        <section style={{ padding: "32px 0 16px" }}>
          <div style={{
            background: "#0a0a0a",
            border: "1px solid #1a1a1a",
            borderRadius: "12px",
            padding: "28px",
          }}>
            <p style={{ fontSize: "1.05rem", lineHeight: 1.8, color: "#d1d5db", margin: "0 0 24px", textAlign: "justify" }}>
              Udbhav is ONGC's enterprise-wide initiative to turn its own employees into AI champions, solving real business problems from within rather than outsourcing the answers. Udbhav 1 lit the spark proving that our own people, given the right support, could build extraordinary solutions. Udbhav 2 picked up that momentum and ran further with it, growing bigger and bolder in both ambition and scale. The journey began on 9th January and built steadily over the months that followed, so it was only fitting that its finale, Demo Day, held on 15th July, matched that scale, bringing the entire journey to a close in a manner as befitting as the initiative itself.
            </p>

            <div style={{ clear: "both", content: '""', display: "table", width: "100%" }}>
              <ImageComponent
                src="/images/extracted_images/image175.jpg"
                alt="Demo Day Presentation"
                className="w-full md:w-1/2 float-none md:float-right mb-6 md:ml-6 md:mb-4 rounded-lg"
              />
              <p style={{ fontSize: "1.05rem", lineHeight: 1.8, color: "#d1d5db", margin: "0 0 24px", textAlign: "justify" }}>
                15th July: day of the Final Presentation, the Darpan Room at ONGC's head office came alive at 9:30 AM sharp, as the CIO opened Demo Day with a formal address that set the tone for what was to follow with not a showcase of slides, but with an inspirational talk of what ONGC's own people are capable of when given the trust, the tools, and the time to build. The five jury members, felicitated at the outset, took their seats not as distant evaluators, but as partners invested in seeing this journey through to its conclusion.
              </p>
              <p style={{ fontSize: "1.05rem", lineHeight: 1.8, color: "#d1d5db", margin: "0", textAlign: "justify" }}>
                Across the day, 25 teams joined online from their locations, one after another, to present what they had built. Each was given 10 minutes to walk through their idea, their approach, and most importantly the results and gains they had already realized. A 5-minute Q&A with the jury followed each presentation, turning the day into a continuous dialogue between builders and evaluators, rather than a one-way pitch.
              </p>
            </div>
          </div>
        </section>

        {/* IMAGE #3 - Section divider */}
        <section style={{ padding: "32px 0", textAlign: "center" }}>
          <ImageComponent src="/images/extracted_images/image1711.png" alt="Section Divider" />
        </section>

        {/* Real Solutions, Real Results */}
        <section style={{ padding: "32px 0", borderTop: "1px solid #111" }}>
          <div style={{ textAlign: "left", marginBottom: "28px" }}>
            <h2 className="text-xl sm:text-2xl md:text-3xl font-extrabold mt-2 mb-0 bg-gradient-to-r from-green-400 via-emerald-400 to-red-400 bg-clip-text text-transparent tracking-tight text-center">
              Real Solutions, Real Results
            </h2>
          </div>

          <div style={{
            background: "#0a0a0a",
            border: "1px solid #1a1a1a",
            borderRadius: "12px",
            padding: "28px",
          }}>
            <div style={{ clear: "both", content: '""', display: "table", width: "100%" }}>
              <ImageComponent
                src="/images/extracted_images/image12.png"
                alt="Real Solutions Illustration"
                className="w-full md:w-1/2 float-none md:float-right mb-6 md:ml-6 md:mb-4 rounded-lg"
              />
              <p style={{ fontSize: "1.05rem", lineHeight: 1.8, color: "#d1d5db", marginBottom: "24px", textAlign: "justify" }}>
                What stood out through the day wasn't just the polish of the presentations but the substance behind them. Team after team had built working solutions using ONGC's own existing systems and data, and many were already realizing tangible benefits even at the proof-of-concept stage. These weren't hypothetical use cases waiting for future validation; they were early wins, already changing how work gets done.
              </p>
              <p style={{ fontSize: "1.05rem", lineHeight: 1.8, color: "#d1d5db", marginBottom: "24px", textAlign: "justify" }}>
                The jury's reaction said as much as any scorecard could. Presentation after presentation impressed not just for the ideas themselves, but for how far the teams, people who had done very little coding until now, from Drilling, Finance, HR, Subsurface, and every corner of the organization, had come in translating an AI concept into an operational reality.
              </p>
              <p style={{ fontSize: "1.05rem", lineHeight: 1.8, color: "#d1d5db", margin: 0, textAlign: "justify" }}>
                And that, in the end, is the real story of Udbhav. Long before this was about dashboards and models, it was about proving a simple but powerful idea: that the people closest to a problem are often best placed to solve it, if only they're equipped with the confidence and capability to try. Udbhav 2.0 gave hundreds of ONGC employees exactly that - the chance to step out of their day-to-day roles and into the shoes of innovators, armed with AI, real data, and the backing of the organization.
              </p>
            </div>
          </div>
        </section>

        {/* A Fitting Close */}
        <section style={{ padding: "32px 0", borderTop: "1px solid #111" }}>
          <div style={{ textAlign: "left", marginBottom: "28px" }}>
            <h2 className="text-xl sm:text-2xl md:text-3xl font-extrabold mt-2 mb-0 bg-gradient-to-r from-green-400 via-emerald-400 to-red-400 bg-clip-text text-transparent tracking-tight text-center">
              A Fitting Close
            </h2>
          </div>
          <div style={{
            background: "#0a0a0a",
            border: "1px solid #1a1a1a",
            borderRadius: "12px",
            padding: "28px",
          }}>
            <p style={{ fontSize: "1.05rem", lineHeight: 1.8, color: "#d1d5db", marginBottom: "24px", textAlign: "justify" }}>
              In the end, the jury faced the hardest task of all: choosing winners from a field of executions that had surpassed every expectation, each one worthy of an award in its own right. Through days of deliberation, there was a quiet sense that something meaningful had already concluded, not merely an event, but a chapter in ONGC's ongoing transformation.
            </p>

            <div className="flex flex-col md:flex-row md:items-center gap-6 mb-10 w-full">
              <div className="md:w-1/2">
                <p style={{ fontSize: "1.05rem", lineHeight: 1.8, color: "#d1d5db", margin: 0, textAlign: "justify" }}>
                  Demo Day had already delivered its most important outcome before a single winner was named: proof that Udbhav's promise of turning ONGC's own employees into AI champions isn't aspirational anymore. It's real, it's working, and on 15th July, it stood fully realized in the Darpan Room. What remained now was simply to recognize those who had taken that promise furthest.
                </p>
              </div>
              <div className="md:w-1/2">
                <ImageComponent
                  src="/images/extracted_images/image1051.jpg"
                  alt="Demo Day Success"
                  className="w-full rounded-lg"
                />
              </div>
            </div>

            <h2 className="text-xl sm:text-2xl md:text-3xl font-extrabold mb-6 bg-gradient-to-r from-green-400 via-emerald-400 to-red-400 bg-clip-text text-transparent tracking-tight text-center clear-both pt-4">
              Finally the Results ...
            </h2>

            <p style={{ fontSize: "1.05rem", lineHeight: 1.8, color: "#d1d5db", marginBottom: "24px", textAlign: "justify" }}>
              Following the jury's deliberations, Udbhav 2.0 announced its award winners, recognising teams whose solutions stood out for impact, innovation, and execution across ONGC's business functions, from Subsurface and Drilling to HSE, Finance, and Digital Operations.
            </p>
            <p style={{ fontSize: "1.05rem", lineHeight: 1.8, color: "#d1d5db", marginBottom: "24px", textAlign: "justify" }}>
              This edition also debuts a new category of awards: the Pravartak (प्रवर्तक) Award, given to finalists of earlier edition (Udbhav 1) for taking their solution to implementation across ONGC. This is Udbhav's highest honour and learn more what it truly recognizes later in this article.
            </p>
            <p style={{ fontSize: "1.05rem", lineHeight: 1.8, color: "#fff", fontWeight: "700", marginBottom: "0", textAlign: "center" }}>
              Click on any team below to view the team members.
            </p>
          </div>
        </section>

        {/* SEARCH AND GRID AWARDS SECTION */}
        <section style={{ padding: "32px 0", marginTop: "32px" }}>

          {/* SEARCH INPUT */}
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '40px' }}>
            <input
              type="text"
              placeholder="Search by title, team member, domain, or category..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              style={{
                width: '100%',
                maxWidth: '600px',
                padding: '12px 20px',
                borderRadius: '30px',
                border: '1px solid #1a1a1a',
                background: '#111',
                color: '#fff',
                fontSize: '1rem',
                outline: 'none',
                boxShadow: '0 4px 12px rgba(0,0,0,0.5)',
                transition: 'border-color 0.3s'
              }}
              onFocus={(e) => e.target.style.borderColor = '#4ade80'}
              onBlur={(e) => e.target.style.borderColor = '#1a1a1a'}
            />
          </div>

          {/* Dynamic Nested Grid Rendering */}

          {/* Pravartak Award */}
          {pravartakWinners.length > 0 && (
            <AwardCategoryBox
              title="Pravartak (प्रवर्तक) Award"
              subtitle={<>When Commitment Outlasts the Applause<br /><span style={{ fontSize: '0.9rem', fontWeight: 500 }}>Finalists of Udbhav 1 with ONGC-wide impact.</span></>}
            >
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 350px), 1fr))", gap: "24px" }}>
                {pravartakWinners.map((winner, idx) => (
                  <ClickableTeamCard key={`pravartak-${idx}`} winner={winner} onClick={setSelectedTeam} />
                ))}
              </div>
            </AwardCategoryBox>
          )}

          {/* The Champions */}
          {championWinners.length > 0 && (
            <AwardCategoryBox
              title="The Champions"
              subtitle={<>The undisputed leaders of Udbhav 2.<br /><span style={{ fontSize: '0.9rem', fontWeight: 500 }}>The best team with the best project and perfect implementation.</span></>}
            >
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 350px), 1fr))", gap: "24px" }}>
                {championWinners.map((winner, idx) => (
                  <ClickableTeamCard key={`champion-${idx}`} winner={winner} onClick={setSelectedTeam} />
                ))}
              </div>
            </AwardCategoryBox>
          )}

          {/* 1st Runner-Up */}
          {firstRunnerUpWinners.length > 0 && (
            <AwardCategoryBox
              title="1st Runner-Up"
              subtitle={<>Udbhav 2 Winners<br /><span style={{ fontSize: '0.9rem', fontWeight: 500 }}>Great Teams in Second Place</span></>}
            >
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 350px), 1fr))", gap: "24px" }}>
                {firstRunnerUpWinners.map((winner, idx) => (
                  <ClickableTeamCard key={`1strunnerup-${idx}`} winner={winner} onClick={setSelectedTeam} />
                ))}
              </div>
            </AwardCategoryBox>
          )}

          {/* 2nd Runner-Up */}
          {secondRunnerUpWinners.length > 0 && (
            <AwardCategoryBox
              title="2nd Runner-Up"
              subtitle={<>Udbhav 2 Winners<br /><span style={{ fontSize: '0.9rem', fontWeight: 500 }}>Great Teams in Top 3</span></>}
            >
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 350px), 1fr))", gap: "24px" }}>
                {secondRunnerUpWinners.map((winner, idx) => (
                  <ClickableTeamCard key={`2ndrunnerup-${idx}`} winner={winner} onClick={setSelectedTeam} />
                ))}
              </div>
            </AwardCategoryBox>
          )}

          {/* Special Jury Award */}
          {specialJuryWinners.length > 0 && (
            <AwardCategoryBox
              title="Special Jury Award"
              subtitle={<>The most promising award for efforts, Technical growth, and value to ONGC</>}
            >
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 350px), 1fr))", gap: "24px" }}>
                {specialJuryWinners.map((winner, idx) => (
                  <ClickableTeamCard key={`specialjury-${idx}`} winner={winner} onClick={setSelectedTeam} />
                ))}
              </div>
            </AwardCategoryBox>
          )}

          {/* Individual Category Awards */}
          {individualCategories.some(cat => filteredWinnersData.some(w => w.category === cat)) && (
            <AwardCategoryBox
              title="Individual Category Awards"
              subtitle={<>Recognizing the Unique Strengths and Contributions of Every Team</>}
            >
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 400px), 1fr))", gap: "24px" }}>
                {individualCategories.map((cat, catIdx) => {
                  const catWinners = filteredWinnersData.filter(w => w.category === cat);
                  if (catWinners.length === 0) return null;
                  return (
                    <IndividualCategoryBox key={`indiv-cat-${catIdx}`} title={cat}>
                      {catWinners.map((winner, idx) => (
                        <ClickableTeamCard key={`indiv-${catIdx}-${idx}`} winner={winner} onClick={setSelectedTeam} />
                      ))}
                    </IndividualCategoryBox>
                  );
                })}
              </div>
            </AwardCategoryBox>
          )}

          {/* Fallback for completely empty search */}
          {filteredWinnersData.length === 0 && (
            <div style={{ textAlign: "center", color: "#9ca3af", padding: "40px 0" }}>
              <p>No teams match your search query.</p>
            </div>
          )}

          {/* Special Awards */}
          <div style={{
            background: "#fbbf24",
            borderRadius: "16px",
            padding: "2px",
            marginBottom: "32px",
            boxShadow: "0 10px 25px rgba(0,0,0,0.4)",
            marginTop: "32px"
          }}>
            <div style={{
              background: "#fbbf24",
              color: "#000",
              padding: "24px",
              textAlign: "center",
              borderTopLeftRadius: "14px",
              borderTopRightRadius: "14px",
            }}>
              <h2 style={{ fontSize: "2rem", fontWeight: 900, margin: 0, color: "#000" }}>Special Awards</h2>
            </div>
            <div style={{
              background: "#fbbf24",
              borderBottomLeftRadius: "14px",
              borderBottomRightRadius: "14px",
              padding: "0 24px 24px 24px",
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 300px), 1fr))",
              gap: "24px"
            }}>
              {/* Best Emergence Award */}
              <div style={{ display: "flex", flexDirection: "column" }}>
                <h3 style={{ textAlign: "center", fontSize: "1.3rem", fontWeight: 800, color: "#000", marginBottom: "16px" }}>Best Emergence Award</h3>
                <div
                  onClick={() => { if (shrishtiTeam) setSelectedTeam(shrishtiTeam); }}
                  style={{
                    background: "#fff",
                    borderRadius: "4px",
                    padding: "16px",
                    color: "#000",
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    cursor: "pointer",
                    transition: "transform 0.2s, box-shadow 0.2s"
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.transform = "translateY(-4px)";
                    e.currentTarget.style.boxShadow = "0 8px 15px rgba(0,0,0,0.2)";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "none";
                  }}>
                  <div className="flex flex-col sm:flex-row items-center gap-4 mb-4">
                    <div className="w-full sm:w-[120px]" style={{
                      background: "#fbbf24",
                      padding: "12px",
                      borderRadius: "4px",
                      fontWeight: 700,
                      textAlign: "center",
                      flexShrink: 0
                    }}>
                      Ms. Shrishti Awasthi
                    </div>
                    <div className="text-center sm:text-left items-center sm:items-start" style={{ fontWeight: 500, fontSize: "1.05rem", lineHeight: 1.4, display: "flex", flexDirection: "column", gap: "8px" }}>
                      Hard Solo work with promising future in Udbhav
                      <span className="justify-center sm:justify-start" style={{ fontSize: "0.75rem", color: "#6b7280", fontWeight: 600, textTransform: "uppercase", display: "flex", alignItems: "center", gap: "4px" }}>
                        Click to view team <span style={{ fontSize: "0.9rem", color: "#10b981" }}>↗</span>
                      </span>
                    </div>
                  </div>
                  <div className="text-center sm:text-left" style={{ fontSize: "0.85rem", fontWeight: 700 }}>
                    AEE Instrumentation, Mehsana Asset
                  </div>
                </div>
              </div>

              {/* Best Mentor Award */}
              <div style={{ display: "flex", flexDirection: "column" }}>
                <h3 style={{ textAlign: "center", fontSize: "1.3rem", fontWeight: 800, color: "#000", marginBottom: "16px" }}>Best Mentor Award</h3>
                <div
                  onClick={() => { if (rahmanTeam) setSelectedTeam(rahmanTeam); }}
                  style={{
                    background: "#fff",
                    borderRadius: "4px",
                    padding: "16px",
                    color: "#000",
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    cursor: "pointer",
                    transition: "transform 0.2s, box-shadow 0.2s"
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.transform = "translateY(-4px)";
                    e.currentTarget.style.boxShadow = "0 8px 15px rgba(0,0,0,0.2)";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "none";
                  }}>
                  <div className="flex flex-col sm:flex-row items-center gap-4 mb-4">
                    <div className="w-full sm:w-[120px]" style={{
                      background: "#fbbf24",
                      padding: "12px",
                      borderRadius: "4px",
                      fontWeight: 700,
                      textAlign: "center",
                      flexShrink: 0
                    }}>
                      Mr. Rahman A M
                    </div>
                    <div className="text-center sm:text-left items-center sm:items-start" style={{ fontWeight: 500, fontSize: "1.05rem", lineHeight: 1.4, display: "flex", flexDirection: "column", gap: "8px" }}>
                      Selfless work for their team
                      <span className="justify-center sm:justify-start" style={{ fontSize: "0.75rem", color: "#6b7280", fontWeight: 600, textTransform: "uppercase", display: "flex", alignItems: "center", gap: "4px" }}>
                        Click to view team <span style={{ fontSize: "0.9rem", color: "#10b981" }}>↗</span>
                      </span>
                    </div>
                  </div>
                  <div className="text-center sm:text-left" style={{ fontSize: "0.85rem", fontWeight: 700 }}>
                    DGM (P) , Tatipaka - Rajahmundry Asset
                  </div>
                </div>
              </div>
            </div>
          </div>

        </section>

        {/* Pravartak Award Section */}
        <section style={{ padding: "32px 0", borderTop: "1px solid #111", marginTop: "32px" }}>
          <div style={{ textAlign: "center", marginBottom: "28px" }}>
            <h2 className="text-xl sm:text-2xl md:text-3xl font-extrabold mt-2 mb-0 bg-gradient-to-r from-green-400 via-emerald-400 to-red-400 bg-clip-text text-transparent tracking-tight text-center">
              The Pravartak (प्रवर्तक) Award
            </h2>
          </div>
          <div style={{
            background: "linear-gradient(to right, rgba(245, 158, 11, 0.1), rgba(0,0,0,0.5))",
            border: "1px solid rgba(245, 158, 11, 0.3)",
            borderRadius: "12px",
            padding: "28px",
          }}>
            <p style={{ fontSize: "1.05rem", lineHeight: 1.8, color: "#d1d5db", marginBottom: "0", textAlign: "justify" }}>
              This edition also introduces a new category: the Pravartak (प्रवर्तक) Award and it now stands as Udbhav's highest honour. It will recognize finalists from previous editions of Udbhav (Udbhav 1) whose work didn't stop when the program did: long after the spotlight had moved on, these teams selflessly kept building, refining, and pushing their solutions forward until they were adopted and implemented across the organization. From this edition onward, the Pravartak Award will remain open to any finalist from any past edition of Udbhav, winner or not, whose solution goes on to achieve this scale of organization-wide impact. It is, in many ways, the truest reflection of what Udbhav set out to build: not a single moment of recognition, but lasting, selfless follow-through.
            </p>
          </div>
        </section>

        {/* The Road Ahead */}
        <section style={{ padding: "32px 0", borderTop: "1px solid #111" }}>
          <div style={{ textAlign: "center", marginBottom: "28px" }}>
            <h2 className="text-xl sm:text-2xl md:text-3xl font-extrabold mt-2 mb-0 bg-gradient-to-r from-green-400 via-emerald-400 to-red-400 bg-clip-text text-transparent tracking-tight text-center">
              The Road Ahead
            </h2>
          </div>
          <div style={{
            background: "#0a0a0a",
            border: "1px solid #1a1a1a",
            borderRadius: "12px",
            padding: "28px",
          }}>
            <p style={{ fontSize: "1.05rem", lineHeight: 1.8, color: "#d1d5db", marginBottom: "18px", textAlign: "justify" }}>
              Udbhav was never built as a one-time event. It was designed as a habit, a recurring way for ONGC to keep turning its own people into problem-solvers, one use case at a time. Demo Day closes this chapter, but not the mission behind it.
            </p>
            <p style={{ fontSize: "1.05rem", lineHeight: 1.8, color: "#d1d5db", marginBottom: "18px", textAlign: "justify" }}>
              The teams that presented on 15th July won't stop building. Neither will the hundreds of others who took part but didn't make the winners' list, many of whom now carry a new skill and a new way of looking at their work. That is the harder-to-measure success of Udbhav. It doesn't end when the trophies are handed out.
            </p>
            <p style={{ fontSize: "1.05rem", lineHeight: 1.8, color: "#d1d5db", marginBottom: "0", textAlign: "justify" }}>
              If Udbhav 2 proved that the model works, the road ahead points naturally towards Udbhav 3, another chance for more employees to step up, more real problems to be solved, and more proof that innovation at ONGC doesn't need to come from outside. Udbhav isn't a one-off event. It's a continuous, unstoppable movement, and this is only the next step in it.
            </p>
          </div>
        </section>

        {/* Jury and Team Section */}
        <section style={{ padding: "32px 0", borderTop: "1px solid #111" }}>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: "24px" }}>
            <div style={{ background: "#0a0a0a", border: "1px solid #1a1a1a", borderRadius: "12px", padding: "28px" }}>
              <h3 className="text-lg sm:text-xl md:text-2xl font-extrabold mb-4 bg-gradient-to-r from-green-400 via-emerald-400 to-red-400 bg-clip-text text-transparent tracking-tight text-center">With Gratitude: The Jury</h3>
              <p style={{ fontSize: "0.95rem", lineHeight: 1.6, color: "#9ca3af", marginBottom: "16px", textAlign: "justify" }}>
                None of this would have been possible without the jury members who gave generously of their time, expertise, and encouragement across a long day of presentation. Their guidance shaped not just the final rankings, but the quality of thinking every team brought to the table.
              </p>
              <ul style={{ listStyleType: "none", padding: 0, margin: 0, color: "#d1d5db", fontSize: "0.95rem", lineHeight: 1.8 }}>
                <li>• Shri Sheel Sood, ED - Chief HRD</li>
                <li>• Shri Ajay Kumar Singh, ED - President, Planning & Transformation</li>
                <li>• Shri Allu Sridhar, GGM (P) - Chief Well Services</li>
                <li>• Shri S Vinod Kumar, GGM (Elect) - Chief Technical Services</li>
                <li>• Shri Chandra Sekhar Davuluri, GGM - Head, Digital & Technology Officer</li>
              </ul>
            </div>

            <div style={{ background: "#0a0a0a", border: "1px solid #1a1a1a", borderRadius: "12px", padding: "28px" }}>
              <h3 className="text-lg sm:text-xl md:text-2xl font-extrabold mb-4 bg-gradient-to-r from-green-400 via-emerald-400 to-red-400 bg-clip-text text-transparent tracking-tight text-center">Behind Every Chapter, A Team</h3>
              <p style={{ fontSize: "0.95rem", lineHeight: 1.6, color: "#9ca3af", marginBottom: "16px", textAlign: "justify" }}>
                Udbhav doesn't run itself. The program continues to be anchored by the sponsorship and guidance of Shri Vinod Kumar Chaudhary, ED - CIO, along with Shri Manoj Kumar Kujur, GGM (E&T) - Head Communication, and Shri Niyazi Farooque Ahmad, GGM (E&T) - Head DCOE whose leadership has been central to Udbhav at every stage.
              </p>
              <p style={{ fontSize: "0.95rem", lineHeight: 1.6, color: "#9ca3af", margin: 0, textAlign: "justify" }}>
                Udbhav initiative has been conducted by a dedicated team on the ground, led by Shri Rishi Raj Vyas, GM (E&T), supported by Ms. Nidhi Verma, Executive Engineer (I.E.) and Oges team, among others who worked tirelessly to make Udbhav 2.0 a reality.
              </p>
            </div>
          </div>
        </section>

        <section style={{ padding: "32px 0", borderTop: "1px solid #111" }}>
          <img src="/images/TeamImage2.png" alt="Udbhav 2.0 Banner" style={{ width: "100%", maxWidth: "900px", borderRadius: "12px", boxShadow: "0 4px 20px rgba(0,0,0,0.5)", display: "block", margin: "0 auto" }} />
        </section>
      </main>

      {/* Floating Scroll to Top Button */}
      {showScroll && (
        <button
          onClick={scrollBack}
          style={{
            position: 'fixed',
            bottom: '40px',
            right: '40px',
            width: '50px',
            height: '50px',
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #4ade80, #34d399)',
            color: '#000',
            border: 'none',
            boxShadow: '0 4px 15px rgba(0,0,0,0.5)',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '1.5rem',
            zIndex: 1000,
            transition: 'opacity 0.3s, transform 0.3s',
            opacity: showScroll ? 1 : 0,
            transform: showScroll ? 'scale(1)' : 'scale(0.8)'
          }}
          aria-label="Scroll back or to top"
          onMouseOver={(e) => e.currentTarget.style.transform = "scale(1.1)"}
          onMouseOut={(e) => e.currentTarget.style.transform = "scale(1)"}
        >
          {returnScrollPos > 0 ? '↺' : '↑'}
        </button>
      )}
    </div>
  );
}